
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';


function AddTipoObjetivo ({ handleNewTipoObjetivo, editTipoObjetivo, cancelarEdicion }){
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    // Obtener la fecha y hora actual
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

     // Convertir a una cadena en formato ISO 8601
        const fechaFormateada = obtenerFechaISOsinZ();
        // Carga inicial de datos si estamos en modo edición
        useEffect(() => {
            if (editTipoObjetivo) {
                setDescripcion(editTipoObjetivo.tipoObjetivo); // Cargar la descripción de la raza para editar
                setModificacion(2);
                setIngresadoPor(editTipoObjetivo.ingresadoPor);
    
            } else {
                setDescripcion(''); // Resetear la descripción si no estamos editando
                setModificacion(1);
                setIngresadoPor('');
    
            }
        }, [editTipoObjetivo]);
    
        const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editTipoObjetivo ? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editTipoObjetivo ? `${server}/CrmTipoObjetivoCampaniums/${editTipoObjetivo.id}` : `${server}/CrmTipoObjetivoCampaniums`;

            const tipoObjetivo = { 
                id:editTipoObjetivo ? editTipoObjetivo.id:0,
                tipoObjetivo: descripcion,
                IngresadoPor: !editTipoObjetivo ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editTipoObjetivo ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                fechaIngreso: fechaFormateada
            };
            Object.keys(tipoObjetivo).forEach(key => tipoObjetivo[key] === undefined && delete tipoObjetivo[key]);
    
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(tipoObjetivo),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setDescripcion('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                           handleNewTipoObjetivo();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el tipo de objetivo',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

    const handleCancelarEdicion = () => {
        setDescripcion('');
        setModificacion(1);
        setIngresadoPor('');
        if (cancelarEdicion) cancelarEdicion();
    }

    return (
        <>
        <h2>{editTipoObjetivo ? 'Editar Tipo Objetivo' : 'Agregar Nueva Tipo'}</h2>
        <br />
        <form id="formTipoObjetivo" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionTipoObjetivo">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionTipoObjetivo"
                        required="required"
                        className="form-control"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                    />
                </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Tipo Objetivo')}>
                        {editTipoObjetivo ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editTipoObjetivo && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddTipoObjetivo;